import React from 'react'

const SearchIcon = (props) => {
  return(
    <svg xmlns="http://www.w3.org/2000/svg" width="17.602" height="17.6" viewBox="0 0 17.602 17.6"><path d="M2.089 12.188a7.142 7.142 0 0 1 10.1-10.1 7 7 0 0 1 1.074 8.619.3.3 0 0 0 .041.358l3.644 3.644a1.664 1.664 0 0 1 .255 2.382l-.111.111a1.664 1.664 0 0 1-2.382-.255l-3.636-3.636a.3.3 0 0 0-.366-.049 7 7 0 0 1-8.619-1.074zm8.781-1.319a5.277 5.277 0 1 0-7.463 0 5.283 5.283 0 0 0 7.463 0z" transform="translate(-.001)" fill="#fff"/><path d="M119.6 54.265a.737.737 0 0 0 .678-1.024 4.645 4.645 0 0 0-6.081-2.465.737.737 0 1 0 .575 1.358 3.169 3.169 0 0 1 4.149 1.682.737.737 0 0 0 .679.449z" transform="translate(4.561 2.858) translate(-113.752 -50.409)" fill={props.fill}/></svg>
  )
}

export default SearchIcon